import { RevenueItemColumn } from "@/pages/deals/components/commercials/DealCommercialsV2/ContractTermsV2/types";
import { TermsChangeSet, TermsFieldChange } from "./types";

export type TermsColumnChanges = Partial<
  Record<RevenueItemColumn, TermsFieldChange[]>
>;

// Which cell carries the dot for each field the change set reports; unlisted fields get none.
const FIELD_COLUMN: Record<string, RevenueItemColumn> = {
  serviceItemId: RevenueItemColumn.SERVICE,
  serviceItemName: RevenueItemColumn.SERVICE,
  customDuration: RevenueItemColumn.PERIOD,
  serviceStartDate: RevenueItemColumn.PERIOD,
  serviceEndDate: RevenueItemColumn.PERIOD,
  customServiceDuration: RevenueItemColumn.PERIOD,
  autoRenewal: RevenueItemColumn.PERIOD,
  customOptOutDate: RevenueItemColumn.PERIOD,
  quantity: RevenueItemColumn.QUANTITY,
  pricePerUnit: RevenueItemColumn.PRICING,
  serviceItemPricingId: RevenueItemColumn.PRICING,
  customBillingFrequency: RevenueItemColumn.BILLING,
  billingStartDate: RevenueItemColumn.BILLING,
  billingEndDate: RevenueItemColumn.BILLING,
  eqPaymentsNumOfPayments: RevenueItemColumn.BILLING,
  eqPaymentsBillingFrequency: RevenueItemColumn.BILLING,
  isDiscountPercentage: RevenueItemColumn.DISCOUNT,
  discountAmount: RevenueItemColumn.DISCOUNT,
  total: RevenueItemColumn.TOTAL,
  totalLocal: RevenueItemColumn.TOTAL
};

// Groups the change set's diffs by revenue item and then by the cell that shows them.
export const buildTermsColumnChanges = (
  changeSet: TermsChangeSet | null
): Record<string, TermsColumnChanges> => {
  const byItem: Record<string, TermsColumnChanges> = {};
  changeSet?.items.forEach((item) => {
    if (!item.revenueItemId || item.status !== "MODIFIED") return;
    const columns: TermsColumnChanges = {};
    item.changedFields.forEach((change) => {
      const column = FIELD_COLUMN[change.field];
      if (!column) return;
      columns[column] = [...(columns[column] ?? []), change];
    });
    byItem[item.revenueItemId] = columns;
  });
  return byItem;
};
